
const toggleClassDnone = (id) => {
    document.getElementById(id).classList.toggle("d-none");
}
const el = document.querySelectorAll('[id*="moreLink_"]');
for(let i=0;i<el.length;i++){
el[i].addEventListener('click', e => {
    toggleClassDnone(`expData${i}`);
    toggleClassDnone(`dataWrap${i}`);
    toggleClassDnone(`readMoreID${i}`);
    toggleClassDnone(`readLessID${i}`);
})
};